import React from 'react';
import {
  ArticleContent,
  ArticleMainImage,
  ArticleTitleWithoutMetaData,
  AuthorsWithRoundImage,
  ContentWithoutSidebar,
  FullWidthPostMainContent,
  LARGE_SCREEN_SIZE,
  MainCategory,
  OpenWeb,
  PostContentWithAside,
  RecommendationsAdvertisement,
  Slideshow,
  Sponsor,
  SwitchableShareMenu,
} from 'mm-ui-components';
import {
  ArticleComponentDataProps,
  FiniteScrollArticleComponentDataProps,
  MainArticleComponentDataProps,
} from '../utils/articleComponent.utils';
import { createBlocksWidth } from '../postPage.util';
import { useFiniteScrollBrowserURLManagerRegistration } from '../../components/finiteScroll/FiniteScrollBrowserURLManager';

const defaultBlocksWidths = createBlocksWidth(740, 730, 640);

const overrideBlocksWidths = {
  image: createBlocksWidth(760, 600, 660),
};
const coverWidth = createBlocksWidth(1080, 730, 640);
const openWebMargins = {
  left: 5,
  right: 0,
};

export const OdesaArticleComponent: React.FunctionComponent<ArticleComponentDataProps> = props => {
  const {
    mainCategory,
    title,
    by,
    updatedAt,
    updatedAtISO,
    authors,
    shareConfig,
    cover,
    siteName,
    templateName,
    sponsor,
    slideshow,
    body,
    sideBar1Id,
    sideBar2Id,
    showRecommendationsAdvertisement,
    revcontentWidgetID,
    createdAt,
    createdAtISO,
    tags,
    md5hashPostCanonicalUrl,
    openWebId,
    sideBar2AdOnSuccess,
    sideBar1AdOnSuccess,
    mainArticleURL,
  } = props;
  const { canonical } = props as MainArticleComponentDataProps;
  const { articleUrl } = props as FiniteScrollArticleComponentDataProps;
  const url = mainArticleURL || canonical || articleUrl;
  const ref = useFiniteScrollBrowserURLManagerRegistration(url as string);
  return (
    <div ref={ref}>
      <ContentWithoutSidebar maxWidth={LARGE_SCREEN_SIZE}>
        <FullWidthPostMainContent>
          <header>
            {mainCategory ? (
              <MainCategory
                {...mainCategory}
                marginFactor={{
                  largeMarginFactor: 1,
                  mediumMarginFactor: 1.5,
                  smallMarginFactor: 1,
                }}
              />
            ) : null}
            <ArticleTitleWithoutMetaData title={title} />
            <AuthorsWithRoundImage
              by={by}
              authors={authors}
              updatedAt={updatedAt}
              updatedAtISO={updatedAtISO}
              createdAt={createdAt}
              createdAtISO={createdAtISO}
            />
            <ArticleMainImage
              {...cover}
              siteName={siteName}
              templateName={templateName}
              defaultBlocksWidths={coverWidth}
              paddingOverride={{ largePadding: 1, mediumPadding: 0, smallPadding: 0 }}
            />
          </header>
          {sponsor ? <Sponsor {...sponsor} /> : null}
          <SwitchableShareMenu shareConfig={shareConfig} canonical={url} />
          <PostContentWithAside adId1={sideBar1Id} adId2={sideBar2Id} adOnSuccess1={sideBar1AdOnSuccess} adOnSuccess2={sideBar2AdOnSuccess}>
            <Slideshow {...slideshow} blockWidths={defaultBlocksWidths}>
              <ArticleContent
                body={body}
                templateName={templateName}
                siteName={siteName}
                defaultBlocksWidths={defaultBlocksWidths}
                overrideBlocksWidths={overrideBlocksWidths}
              />
            </Slideshow>
          </PostContentWithAside>
        </FullWidthPostMainContent>
        <SwitchableShareMenu shareConfig={shareConfig} canonical={url} smallScreenOnly />
        {showRecommendationsAdvertisement
          ? <RecommendationsAdvertisement revcontentWidgetID={revcontentWidgetID} /> : null}
        {openWebId && md5hashPostCanonicalUrl
        && (
          <OpenWeb
            spotId={openWebId}
            postCanonicalUrl={url}
            tags={tags}
            largeScreenMarginFactors={openWebMargins}
            md5hashPostCanonicalUrl={md5hashPostCanonicalUrl}
          />
        )}
      </ContentWithoutSidebar>
    </div>
  );
};
